import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e080f3ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dialog-title-text" }, " Configurações ", -1))
const _hoisted_3 = { class: "dialog-content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Ativar alto contraste")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dialog-text" }, [
  /*#__PURE__*/_createTextVNode(" Palavra Quadrada é baseado em "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://squareword.org/" }, "Squareword"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_redirect_item_section = _resolveComponent("redirect-item-section")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref: "dialogRef",
    onHide: _ctx.onDialogHide
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_q_btn, {
              flat: "",
              onClick: _ctx.onDialogHide,
              icon: "close"
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_q_card_section, { class: "dialog-section" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item, {
                      clickable: "",
                      onClick: _ctx.toggle
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, { class: "dialog-text" }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_item_section, { avatar: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_toggle, {
                              onClick: _ctx.toggle,
                              "model-value": _ctx.colorBlindData.isActive
                            }, null, 8, ["onClick", "model-value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_redirect_item_section, {
                      class: "dialog-text",
                      icon: 'fab fa-twitter',
                      title: 'Twitter',
                      redirectLink: 'https://twitter.com/collbreno'
                    }, null, 8, ["redirectLink"]),
                    _createVNode(_component_redirect_item_section, {
                      class: "dialog-text",
                      icon: 'mail',
                      title: 'E-mail',
                      redirectLink: 'mailto:brenocoll99@gmail.com'
                    }, null, 8, ["redirectLink"]),
                    _createVNode(_component_redirect_item_section, {
                      class: "dialog-text",
                      icon: 'fab fa-github',
                      title: 'Github',
                      redirectLink: 'https://github.com/collbreno'
                    }, null, 8, ["redirectLink"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_card_section, { class: "dialog-section" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}